import React from "react";
import { Field } from "formik";

import { Input as ChakraInput, Text } from "@chakra-ui/core";

export const Input = (props) => (
    <>
        {props?.label?.length > 0 && props?.type !== "hidden" && (
            <>
                <Text mb="8px" fontWeight={600}>
                    {props.label}
                    {props.required && (
                        <Text as="sup" color="brand.orange">
                            *
                        </Text>
                    )}
                </Text>
            </>
        )}

        <Field name={props.name}>
            {({ field, form }) => (
                <ChakraInput
                    borderColor={
                        field?.value?.length > 0
                            ? "brand.slateGrey"
                            : "brand.lightGrey"
                    }
                    color={"brand.black"}
                    _hover={{ borderColor: `brand.black` }}
                    _placeholder={{ color: "brand.slateGrey" }}
                    height="45px"
                    fontSize={`14px`}
                    borderRadius={0}
                    backgroundColor="brand.lightGrey"
                    _focus={{
                        borderColor: `brand.orange`,
                    }}
                    mb={
                        props.help
                            ? `5px`
                            : {
                                  base: `15px`,
                                  md: `30px`,
                              }
                    }
                    aria-label={props.label}
                    onChange={(e) =>
                        form.setFieldValue(field.name, e.target.value)
                    }
                    isDisabled={form.isSubmitting || props.disabled}
                    {...props}
                />
            )}
        </Field>

        {props?.help?.length > 0 && props?.type !== "hidden" && (
            <Text
                color="brand.grey"
                fontSize="sm"
                mb={{
                    base: `15px`,
                    md: `30px`,
                }}
            >
                {props.help}
            </Text>
        )}
    </>
);
